import React, { useEffect, useMemo, useState } from "react";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import Select from "react-select";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "35px",
  fontWeight: "bold",
};

const SendMessageNonMembers = () => {

  const initialFormData = {
    // companyTypeId: "",
    notification: "",
    msgLink: "",
  }
  const [messageData, setMessageData] = useState(initialFormData)

  //handlechange
  const handleChange = (e) => {
    e.preventDefault()
    const { name, value } = e.target;


    setMessageData({ ...messageData, [name]: value });
  };

  const [isLoading, setisLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!messageData.notification) {
      return toast.error("Message text should not be empty!")
    }
    const formData = Object.fromEntries(
      Object.entries(messageData).filter(([_, value]) => value !== "")
    );
    // return

    setisLoading(true);
    const res = await HttpClient.requestData("send-msg-nonmembers", "POST", formData);
    if (res && res?.status) {
      setisLoading(false);
      setMessageData(initialFormData)
      toast.success("Message sent successfully!");
    } else {
      setisLoading(false);
      toast.error("Error occured!");
    }

  };

  const [profileTypes, setProfileTypes] = useState([]);
  //typeof business
  const getProfileType = async () => {
    const res = await HttpClient.requestData("get-profile-type", "GET", {});

    if (res && res?.status) {
      setProfileTypes(res?.data);
    }
  };

  const [Business, setBusiness] = useState([]);
  //typeof business
  const getBuisinessType = async () => {
    const res = await HttpClient.requestData("view-companyType", "GET", {});

    if (res && res?.status) {
      setBusiness(res?.data);
    }
  };

  const [countries, setCountries] = useState([])
  const memoizedCountryTypes = useMemo(() => countries, [countries])
  //Countries
  const getCountries = async () => {
    try {
      const res = await HttpClient.requestData("countries", "GET", {})

      if (res && res?.status) {
        setCountries(res?.data);
        // if (!location.state) {

        //     setFormThreeData({
        //         ...formThreeData,
        //         phone_code: res1.data[1].phone_code,
        //         whats_code: res1.data[1].phone_code,
        //     });
        // }

        // setFormThreeData({
        //     ...formThreeData,
        //     phone_code: res1.data[0].phone_code,
        //     whats_code: res1.data[0].phone_code,
        // });

      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [CountryWiseState, setCountryState] = useState([]);
  //State
  const getState = async () => {
    const res = await HttpClient.requestData(
      "countrywise-state/" + messageData.country,
      "GET"
    );

    if (res && res?.status) {
      setCountryState(res?.data?.[0]?.states);
    } else {
      setCountryState([])
    }
  };

  useEffect(() => {
    setMessageData({ ...messageData, companyTypeId: "" })
  }, [messageData.profileTypeId]);

  useEffect(() => {
    messageData.country ? getState() : setCountryState([])
    setMessageData({ ...messageData, state: "" });
  }, [messageData.country]);

  useEffect(() => {
    getProfileType()
    getBuisinessType()
    getCountries()
  }, []);

  return (
    <div>
      <CustomLoader loading={isLoading} />

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div style={headLineStyle} className="page-headline">
              Send Update Message to Non-member(s)
            </div>
            <form>
              <div className="row">

                {/* Profile type */}
                <div className={messageData.profileTypeId === "65ddc3d1d569c29c97f6082c" ? "col-md-3" : "col-md-6"}>
                  <label htmlFor="profileType" className="form-label">
                    Profile type <span className="text-danger">*</span>
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    id="profileTypeId"
                    name="profileTypeId"
                    value={messageData.profileTypeId}
                    onChange={(e) => { handleChange(e) }}
                  >
                    <option value="*"> ---Select--- </option>
                    {profileTypes.map((item, i) => (
                      <option key={i} value={item?._id}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>


                {/* company type */}
                {
                  messageData.profileTypeId === "65ddc3d1d569c29c97f6082c" &&
                  <div className="col-md-3">
                    <label htmlFor="CompanyType" className="form-label">
                      Company type <span className="text-danger">*</span>
                    </label>
                    <select
                      type="text"
                      className="form-control"
                      id="companyTypeId"
                      name="companyTypeId"
                      value={messageData.companyTypeId}
                      onChange={(e) => { handleChange(e) }}
                    >
                      <option value="" >All</option>
                      {Business.map((item, i) => (
                        <option key={i} value={item?._id}>
                          {item?.type}
                        </option>
                      ))}
                    </select>
                  </div>
                }


                {/* Country */}
                <div className="col-md-3">
                  <label htmlFor="formGroupExampleInput">Country</label>
                  <select
                    className="form-control"
                    aria-label="Default select example"
                    name="country"
                    value={messageData.country || ""}
                    onChange={(e) => { handleChange(e) }}
                  >
                    <option value="">All</option>
                    {memoizedCountryTypes.map((item, i) =>
                      <option key={i} value={item?._id}>{item?.name}</option>
                    )
                    }
                  </select>
                </div>

                {/* State */}
                <div className="col-md-3">
                  <label htmlFor="formGroupExampleInput">State</label>
                  <select
                    className="form-control"
                    aria-label="Default select example"
                    name="state"
                    value={messageData.state}
                    onChange={(e) => { handleChange(e) }}
                  >

                    <option value="">All</option>
                    {CountryWiseState?.map((item, i) => (
                      <option key={i} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}


                  </select>
                </div>

                <div className="col-md-12 mt-4">
                  <label htmlFor="formGroupExampleInput">
                    Update/Message<span className="text-danger">&nbsp;*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="notification"
                    rows="4"
                    onChange={handleChange}
                    placeholder="Enter the message..."
                    va
                  >
                    {messageData?.notification || ""}
                  </textarea>

                </div>

                <div className="col-md-12 mt-4">
                  <label htmlFor="formGroupExampleInput">
                    Link
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="msgLink"
                    value={messageData?.msgLink || ""}
                    onChange={handleChange}
                  >
                  </input>
                </div>

              </div>
              <div className="row">
                {/* Button */}
                <div className="col-12 d-flex justify-content-end">

                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    className="btn btn-primaryb mt-3"
                    style={{
                      background:
                        "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
                      color: "#fff",
                    }}
                  >
                    Send
                  </button>

                </div>
              </div>
            </form>

          </section>
        </div>
      </div>
    </div>
  );
};

export default SendMessageNonMembers;
